import React from "react";

import { CheckboxChangeEvent, Radio } from "components";

export const CheckboxRound = ({
  checked,
  onChange,
  disabled,
  className = "",
  dataTestId,
}: {
  checked: boolean;
  onChange: (e: CheckboxChangeEvent) => void;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}) => (
  <Radio className={`checkbox-round radio-pill radio-group ${className}`} data-testid={dataTestId} disabled={disabled} checked={checked} onChange={onChange} />
);
